import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import ItemService from "../../../../services/supplier_appCommonService";
import CustomerItemService from "../../../../services/customer_v2_appCommonService";

//Redux
import { useDispatch, useSelector } from "react-redux"; //useDispatch

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";
import toast from "react-hot-toast";
import HeaderText from "../../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { formatDateTime, getCurrentDate } from "../../../../common/Validations";
import Loader from "../../../../Components/Loader";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
// import { useNavigate } from "react-router-dom";
// import CustomerConstants from "../../../../common/CustomerConstants";

const QuotationDetailPageV2 = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Quotation");

  // const navigate = useNavigate();

  let quotationListInfo = useSelector(
    (state) => state?.customer?.quotation?.quotationListInfo?.quotationNr
  ); /* quotationListInfo from store*/

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [itemTableData, setItemTableData] = useState([]);
  const [getDropdownData /*setDropdownData*/] = useState("");

  const [getDisabledStatus, /*setDisabledStatus*/] = useState(true);

  const [disabled, /*setDisabled*/] = useState(true);
  const [userId, setUserId] = useState(true);
  const [userName, setUserName] = useState(true);
  const [getLoader, setLoader] = useState(true);

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [formInputs, setFormInputs] = useState({
    quotationNr: quotationListInfo?.quotationNr,
    qtnVersion: quotationListInfo?.qtnVersion,
    rfxNr: "",
    quotationSubmittedBy: "",
    qtnSubmittedID: "",
    vendorCode: "",
    rfxCategoryDesc: "",
    rfqCreation: "",
    rfxDescription: "",
    rfxVersion: "",
    rfxTitle: "",
    openingrfxType: "",
    productType: "",
    rfxHeaderStatus: "",
    rfxbidType: "",
    rfxNoOfEvaluationType: "",
    rfxCurrency: "",
    rfxTechFocalPersonId: "",
    technicalApprovalType: "",
    plant: "",
    qtnPaymentTerms: "",
    qtnBidderCurrency: "",
    technicalQuoteArticle: "",
    qtnPricingNotes: "",
    unpricedCommercia: "",
    lQuoteArticle: "",
    quotationNotes: "",
    commercialQuoteArticle: "",
    quotationStatus: "",
    buyerResponsible: "",
    companyAddress: "",
    buyerEmail: "",
    initiatorName: "",
    initiator: "",
    createdOn: "",
    buyerConact: "",
    deliveryAddressCodeDesc: "",
    rfxCategoryType: "",
    rfxCateDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    typeOfPurchase: "",
    otherCurrencies: "",
    headerIncoTerms: "",
    incoTermsLocation: "",
    procurementStrategies: "",
    openingDateTime: "",
    closingDateTime: "",
    rfxTypeDesc: "",
    productTypeDesc: "",
    rfxbidTypeDesc: "",
    rfxNoOfEvaluationTypeDesc: "",
    rfxCurrencyCode: "",
    rfxCurrencyDesc: "",
    technicalApprovalTypeDesc: "",
    companyCodeDesc: "",
    plantDesc: "",
    // deliveryAddressCodeDesc: "",
    unpricedCommercialQuoteArticle: "",
    pricingNotes: "",
    qtnIncoTerms: "",
    quotationReference: "",
    acceptanceTermsConditions: "",

    items: [
      {
        qtnItem: 1,
        nstatusItem: "",
        qtnQuantity: 10,
        qtnQuantityUnit: "",
        purchaseDocumentNr: "",
        purchaseDocumentItem: "",
        quotationNr: "",
      },
    ],
    formCOMM: [],
    formTECH: [],
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // const createPo = () => {
  //   navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_ORDER_CREATION); // Navigate to detail page
  // };

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [, /*getINCOTerms*/ setINCOTerms] = useState([]);
  const [, /*getcurrency*/ setcurrency] = useState([]);
  const [, /*getpaymentTerm*/ setpaymentTerm] = useState([]);
  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  /*  PRLineItem*/
  let PRLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row.materialCode} </p>
            <p className="m-0 p-0">{row.materialDescription} </p>
          </div>
        </>
      ),
      width: "180px",
      sortable: true,
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.indentQuantity || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Qtn Quantity ",
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="qtnQuantity"
            name="qtnQuantity"
            value={row.qtnQuantity || 0}
            disabled={disabled}
          />
        </>
      ),
      width: "160px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      width: "200px",
    },
    {
      name: "Unit Price ",
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="quotationUnitPrice"
            name="quotationUnitPrice"
            value={row.quotationUnitPrice || 0}
            disabled={disabled}
          />
        </>
      ),
    },
    {
      name: "Item Value ", // calculation
      selector: (row) => row.qtnitemValue || "--",
      width: "200px",
    },
    {
      name: "Remarks", // input
      selector: (row) => row?.remark || "--",
      cell: (row) => (
        <>
          <TextAreaField
            className="inputBox mt-1"
            id="remark"
            name="remark"
            value={row?.remark}
            disabled={disabled}
          />
        </>
      ),
      width: "200px",
    },
  ];

  // Other Charges
  const [getOtherChargesValue, setOtherChargesValue] = useState(0);
  const [HeaderTextModel, setHeaderTextModel] = useState(false);

  /* Other Charges selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);
  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
  };

  useEffect(() => {
    if (Array.isArray(getHeaderTextSelectedData)) {
      const getTotal = getHeaderTextSelectedData.reduce(
        (accumulator, currentValue) =>
          accumulator + Number(currentValue?.documentText || 0),
        0
      );
      setOtherChargesValue(getTotal);
    } else {
      setOtherChargesValue(0); // fallback if undefined or not array
    }
  }, [getHeaderTextSelectedData]);
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  /* Create Other Charges Modal Function */
  // eslint-disable-next-line no-unused-vars

  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };

  const HeaderTextColumns = [
    {
      name: "Code",
      cell: (row) => (
        <>
          <span>{row.documentId}</span>
        </>
      ),
      width: "30rem",
    },
    {
      name: "Value",
      cell: (row) => (
        <>
          <span>{row.documentText}</span>
        </>
      ),
      width: "30rem",
    },
  ];

  const loadInitialPageData = async () => {
    // setLoading(true);e

    if (quotationListInfo) {
      let obj = {
        documentNumber: quotationListInfo,
        // qtnVersion: quotationListInfo?.qtnVerSAsion,
      };

      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await CustomerItemService.getQuotationDetail(obj).then((item) => {
        if (item?.status === 200) {
          setItemTableData(item?.data[0]?.items);
          setFormInputs(item?.data[0]);

          const supplierList = item?.data[0]?.supplierList;
          if (Array.isArray(supplierList) && supplierList.length > 0) {
            const supplier = supplierList[0];
            setUserId(supplier?.AssociateNumber || supplier?.userId || "");
            setUserName(supplier?.organisationName || "");
          } else {
            setUserId("");
            setUserName("");
          }
          // setHeaderTextSelectedData(item?.data?.othersCharge);
          setHeaderTextSelectedData(item?.data[0]?.othersCharge || []);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
    } else {
      window.history.back();
    }
  };

  useEffect(() => {
    loadInitialPageData();
    getMasterDataFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotationListInfo]);

  //Load Master Data
  const getMasterDataFunc = async () => {
    // 1

    let obj4 = {
      codeType: "INCOTerms",
    };
    await ItemService.getMasterData(obj4).then((item) => {
      if (item?.status === 200) {
        setINCOTerms(item?.data);
      } else {
        setINCOTerms([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj5 = {
      codeType: "currency",
    };
    await ItemService.getMasterData(obj5).then((item) => {
      if (item?.status === 200) {
        setcurrency(item?.data);
      } else {
        setcurrency([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj6 = {
      codeType: "paymentTerm",
    };
    await ItemService.getMasterData(obj6).then((item) => {
      if (item?.status === 200) {
        setpaymentTerm(item?.data);
      } else {
        setpaymentTerm([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    setLoader(false);
  };

  // Get Dropdown data select
  useEffect(() => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.code,
      [getDropdownData?.textDesc]: getDropdownData?.description,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Quotation:
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {formInputs?.quotationNr}
              </span>
              <span>
                {formInputs?.quotationStatus === "Published" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.quotationStatus}
                  </span>
                ) : formInputs?.quotationStatus === "QTN Received" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs?.quotationStatus}
                  </span>
                ) : formInputs?.quotationStatus === "Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {formInputs?.quotationStatus}
                  </span>
                ) : formInputs?.quotationStatus === "Created" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.quotationStatus}
                  </span>
                ) : formInputs?.quotationStatus === "Submitted" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.quotationStatus}
                  </span>
                ) : (
                  formInputs?.quotationStatus
                )}
              </span>
              <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                {userId} - {userName}
              </span>
            </h2>
            <p className="subText">Quotation Details</p>
            <hr />
            {/* <Col
              xs={8}
              md={{ span: 2, offset: 10 }}
              lg={{ span: 2, offset: 10 }}
              className="text-left mb-4"
              // onClick={createPo}
              onClick={() => createPo()}
            >

              <button className="btnInfo">Create PO</button>
            </Col> */}
            <Loader isLoading={getLoader} className={"text-center"} />

            {!getLoader && (
              <>
                {/*quotation Header */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${isCardVisible
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                              }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">QH</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Quotation Header</span>
                          <span className="subHeaderTitle">
                            Header Description
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                        }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Company Name"
                              name="companyCodeDesc"
                              id="companyCodeDesc"
                              placeholder=""
                              value={formInputs?.companyCodeDesc}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="RFQ ID"
                              name="rfxNr"
                              id="rfxNr"
                              placeholder=""
                              value={formInputs?.rfxNr}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Product Type"
                              name="productType"
                              id="productType"
                              value={formInputs?.productType}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="quotationStatus"
                              className="inputBox"
                              label="Quotation Status"
                              name="quotationStatus"
                              placeholder=""
                              value={"New"}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="quotationCreatedOn"
                              className="inputBox"
                              label="Quotation Created Date"
                              name="quotationCreatedOn"
                              placeholder=""
                              value={getCurrentDate("default")}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Buyer Responsible"
                              name="buyerResponsible"
                              placeholder=""
                              value={formInputs.buyerResponsible || ""}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Buyer Contact"
                              name="buyerConact"
                              id="buyerConact"
                              value={formInputs?.buyerConact}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Delivery Address"
                              name="deliveryAddressCodeDesc"
                              id="deliveryAddressCodeDesc"
                              value={formInputs?.deliveryAddressCodeDesc}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Billing Address"
                              name="billingAddress"
                              id="billingAddress"
                              value={formInputs?.billingAddress}
                              // onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Quotation overview */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                              }`}
                            onClick={toggleCardVisibility2}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">QO</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">
                            Quotation Overview
                          </span>
                          <span className="subHeaderTitle">
                            Quotation Overview
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                        }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="RFQ Title:"
                              name="rfxTitle"
                              id="rfxTitle"
                              value={formInputs?.rfxTitle}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="RFQ Description:"
                              name="rfxDescription"
                              id="rfxDescription"
                              value={formInputs?.rfxDescription}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          ></Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Opening Date:"
                              name="openingDateTime"
                              id="openingDateTime"
                              value={formatDateTime(
                                formInputs?.openingDateTime
                              )}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Closing Date:"
                              name="closingDateTime"
                              id="closingDateTime"
                              value={formatDateTime(
                                formInputs?.closingDateTime
                              )}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          ></Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <p className="fw-medium">Supporting Document</p>
                            {(formInputs.supportingDoc && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs.supportingDoc)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Price Shedule / Line Item */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${isCardVisible4
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                              }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PS</span>
                        </Col>
                        <Col xs={12} md={4} lg={4}>
                          <span className="headerTitle">
                            Price Shedule / Line Item
                          </span>
                          <span className="subHeaderTitle">
                            Price Shedule / Line Item
                          </span>
                        </Col>
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${isCardVisible4 ? "visible" : ""
                        }`}
                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              // title=""
                              columns={PRLineItemInitialCol}
                              data={itemTableData}
                              // progressPending={loading}
                              // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                              // pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* other Charges table */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${isCardVisible5
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                              }`}
                            onClick={toggleCardVisibility5}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">OC</span>
                        </Col>

                        <Col xs={4} md={6} lg={6}>
                          <span className="headerTitle">Other Charges</span>
                          <span className="subHeaderTitle">
                            Other Charges Table{" "}
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""
                        }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              // title=""
                              columns={HeaderTextColumns}
                              data={getHeaderTextSelectedData}
                              // progressPending={loading}
                              // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                              // pagination

                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Pricing Summary */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${isCardVisible6
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                              }`}
                            onClick={toggleCardVisibility6}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PS</span>
                        </Col>
                        <Col xs={12} md={4} lg={4}>
                          <span className="headerTitle">Pricing Summary</span>
                          <span className="subHeaderTitle">
                            Pricing Summary{" "}
                          </span>
                        </Col>
                        <Col xs={2} md={1} lg={1} className="">
                          <SourcingCommonFilter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""
                        }`}
                    >
                      <Row className="my-4 ms-3 ">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="d-flex mb-2 jsutify-content-center align-items-center"
                        >
                          <p className="fw-medium">
                            SubTotal Pricing Schedule / Line Items (A){" "}
                          </p>
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="d-flex mb-2 jsutify-content-center align-items-center"
                        >
                          <InputField
                            id="subTotalValue"
                            className="inputBox"
                            name="subTotalValue"
                            placeholder=""
                            value={formInputs?.qtnSubTotalLineItem}
                            disabled={getDisabledStatus}
                          />
                          <p className="ms-4 fw-medium">
                            {" "}
                            {formInputs?.rfxCurrency}
                          </p>
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="d-flex mb-2 jsutify-content-center align-items-center "
                        >
                          <p className="fw-medium">
                            {" "}
                            SubTotal Other Charges (B)
                          </p>
                        </Col>
                        <Col
                          xs={12}
                          md={7}
                          lg={7}
                          className="d-flex mb-2 jsutify-content-center align-items-center "
                        >
                          <InputField
                            id="getOtherChargesValue"
                            className="inputBox"
                            name="getOtherChargesValue"
                            placeholder=""
                            value={getOtherChargesValue}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="d-flex mb-2 jsutify-content-center align-items-center"
                        >
                          <p className="fw-medium">
                            Quotation Gross Total (C = A + B)
                          </p>
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="d-flex mb-2 jsutify-content-center align-items-center"
                        >
                          <InputField
                            id="Closing"
                            className="inputBox"
                            name="qtnTotal"
                            placeholder=""
                            value={formInputs?.qtnTotal}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>

      {/* <CreateOtherChanges
        show={otherchangesmodelshow}
        onHide={hideOtherChangesModel}
        onData={handleDataFromCreateOtherChanges}
      /> */}
      <HeaderText
        index={0}
        headername="Add Other Charges"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="OtherChargesID"
        type="Number"
      />

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default QuotationDetailPageV2;
